import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalFooter } from 'reactstrap';

import { clearModal } from '@shoflo/studio-redux/actions';
import { SceneRenderer } from '@shoflo/polymer';

import ModalHeader from 'components/Modal/Header';
import { PROGRAM_PREVIEW } from 'constants/ModalTypes';

import {
  StyledModal,
  StyledModalBody,
  StyledCloseButton
} from './ProgramPreview.styled';
import sceneBgImage from './transparent_checkered.png';

const bgStyle = {
  backgroundImage: `url(${sceneBgImage})`,
  backgroundSize: 28
};

const ProgramPreview = () => {
  const dispatch = useDispatch();

  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === PROGRAM_PREVIEW
  );
  const scene = useSelector(({ modal }) => modal && modal.initialValue);

  const clearThisModal = () => dispatch(clearModal(PROGRAM_PREVIEW));

  if (scene && isOpen) {
    scene.style = { ...scene.style, ...bgStyle };
  }

  return (
    <StyledModal isOpen={isOpen} toggle={clearThisModal}>
      <ModalHeader>Preview</ModalHeader>
      <StyledModalBody>
        {isOpen && (
          <SceneRenderer
            showMediaControls={true}
            autoPlayMedia={false}
            {...scene}
          />
        )}
      </StyledModalBody>
      <ModalFooter>
        <StyledCloseButton
          color="secondary"
          variant="outlined"
          onClick={clearThisModal}
        >
          Close
        </StyledCloseButton>
      </ModalFooter>
    </StyledModal>
  );
};

export default ProgramPreview;
